<script>
import httpService from '@/core/api/request'
export default {
	data: function() {
		return {}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/orders/mixins.vue